import {text_mod_23, } from "../text/Text.js";
export const module23 = {
  title:
    "Подовжені м’які приголосні звуки​​",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_23, },
    ]
  }
